import { render, staticRenderFns } from "./KnowledgeContract.vue?vue&type=template&id=3cf44ed5&"
import script from "./KnowledgeContract.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContract.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeContract.vue?vue&type=style&index=0&id=3cf44ed5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports